// import YwMenu from "./YwMenu";
// import YwSubMenu from "./YwSubMenu";
// import YwMenuItem from "./YwMenuItem";
// import YwMenuItemGroup from "./YwMenuItemGroup";
// import YwMenuDivider from "./YwMenuDivider";
import { Icon, Menu } from "ant-design-vue";
import "./src/menu.less"
const { SubMenu, Item, ItemGroup, Divider, ...other } = Menu;
const YwMenu = {
	...other,
	name: "YwMenu",
	SubMenu: {
		...SubMenu,
		name: "YwSubMenu",
	},
	Item: {
		...Item,
		name: "YwMenuItem",
	},
	ItemGroup: {
		...ItemGroup,
		name: "YwMenuItemGroup",
	},
	Divider: {
		...Divider,
		name: "YwMenuDivider",
	},
};

// YwMenu.SubMenu = {
// 	...SubMenu,
// 	name: "YwSubMenu",
// };
// YwMenu.Item = {
// 	...Item,
// 	name: "YwMenuItem",
// };
// YwMenu.ItemGroup = {
// 	...ItemGroup,
// 	name: "YwMenuItemGroup",
// };
// YwMenu.MenuItem = {
// 	...Divider,
// 	name: "YwMenuDivider",
// };

YwMenu.install = function (Vue) {
	Vue.component(YwMenu.name, Menu);
	Vue.component(YwMenu.SubMenu.name, Menu.SubMenu);
	Vue.component(YwMenu.Item.name, Menu.Item);
	Vue.component(YwMenu.ItemGroup.name, Menu.ItemGroup);
	Vue.component(YwMenu.Divider.name, Menu.Divider);
	Vue.use(Icon);
};

// const NewMenu = {
// 	...other,
// 	...YwMenu,
// };

export default YwMenu;
